import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { resetBlotterPanelEpics } from './blotterPanel/quoteBlotterPanelEpics';
import { loadFilterStateEpic, persistFilterStateEpic } from './filter/filterStateEpic';
import {
  columnStateChangedEpic,
  fetchColumnDefinitionReceivedEpic,
  loadPreferenceStateEpic,
  pageSizeChangedEpic,
  persistPreferenceStateEpic,
} from './preferenceState/preferenceStateEpics';
import {
  fetchColumnDefinitionEpic,
  fetchQuoteBlotterPlatformsEpic,
  navigateToQuoteBlotterEpic,
} from './quoteBlotterEpics';

export const quotesBlotterEpics = () =>
  withAppCrashIfException(
    'quoteBlotter',
    combineEpics(
      columnStateChangedEpic(), // OK
      fetchColumnDefinitionEpic(), // OK
      fetchColumnDefinitionReceivedEpic(), // OK, should be a thunk

      loadPreferenceStateEpic(), // OK
      persistPreferenceStateEpic(), // OK

      pageSizeChangedEpic(), // OK, should be a thunk

      resetBlotterPanelEpics(), // OK

      loadFilterStateEpic(),
      persistFilterStateEpic(),
      fetchQuoteBlotterPlatformsEpic(),
      navigateToQuoteBlotterEpic(),
    ),
  );
